import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold text-background-50 whitespace-nowrap">
              韩漫之家
            </Link>
            <p className="mt-4 text-sm text-secondary-300 leading-relaxed">
              免费韩漫在线阅读平台，提供高清下拉式韩漫全集，真正实现韩国漫画免费读，让您尽情享受阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              分类浏览
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                首页
              </Link>
              <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                关于我们
              </Link>
              <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                联系我们
              </Link>
              <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                隐私政策
              </a>
              <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                使用条款
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-secondary-300 mb-4">
              获取最新韩漫更新资讯
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-background-50"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              &copy; 2026 韩漫之家 - 免费韩漫在线阅读平台. All rights reserved.
            </p>
            <p className="text-xs text-secondary-400">
              声明：本站所有漫画内容均来源于网络，仅供学习交流使用。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}